import { PARTITION_LIST_API_SYNC_TYPE_TAG } from '../../../../React/PartitionConfiguration/Utils/partitionListSyncTypeDisplay'

/**
 * Synchronisation types a partition can be set to, in the order the partition list filter offers them.
 *
 * These are the tag strings the admin list API publishes in {@code SyncType} (WS
 * {@code ConvertIntegerValueToPartitionSyncTypeString}); the same strings are sent back as the filter value, and
 * the WS marshaller accepts them case insensitively and ignoring separators.
 */
export const PARTITION_LIST_SYNC_TYPE_FILTER_VALUES: readonly string[] = [
    PARTITION_LIST_API_SYNC_TYPE_TAG.SOFT,
    PARTITION_LIST_API_SYNC_TYPE_TAG.ONE_TIME_FULL,
    PARTITION_LIST_API_SYNC_TYPE_TAG.FULL,
    PARTITION_LIST_API_SYNC_TYPE_TAG.SERVICE_PACK
]

/**
 * Communication statuses the partition list can display, in the order the filter offers them.
 *
 * The Status column renders the API's {@code CommsStatus} string as-is, so the filter offers exactly that
 * vocabulary (every WS {@code sTAGVALUE_PROPERTY_PARTITIONXXX_COMMSSTATUS_*} value except the
 * {@code [N/A]} placeholder, which is not a state a partition can be filtered to) and the filter and the
 * column always agree on wording.
 */
export const PARTITION_LIST_STATUS_FILTER_VALUES: readonly string[] = [
    'Running',
    'Running (Warnings)',
    'Synchronising',
    'Synchronised',
    'Synchronised (Warnings)',
    'Synchronised (Comms Inactive/Failed)',
    'Synchronise Pending',
    'Synchronisation Failed',
    'Users Exceed Threshold',
    "Can't Synchronise",
    'Starting Comms',
    'Stopping Comms',
    'Comms Inactive',
    'Comms Failed',
    'Waiting For License',
    'Loading',
    'Out-Of-Service',
    'Unknown'
]
